export default "__VITE_ASSET__BLBi75UI__"